import { uuid } from '@/_core/utils/uuid';
import { ArchiveActivity, RestoreArchivedActivity } from '../../../store';

import * as storymapStoreModule from '../../../store';
import { getCardById } from '../../../store/use';
import { BoardUserActivityType } from '@/api/workspaceSettings/queries';
import { ArchiveActivity as ArchiveActivityCommand, RestoreArchivedActivity as RestoreArchivedActivityCommand } from '../../commands';

export const createArchiveActivityCommand = async (action: ArchiveActivity) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const card = getCardById(action.id);

    const activityId = await uuid.create();

    const boardActivity: any = {
        CardId: card.id,
        CardName: card.title,
        Datetime: new Date().toJSON(),
        OriginalContent: card.title,
        Id: activityId,
        StorymapId: state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
        Type: BoardUserActivityType.ActivityArchived,
    };

    const cmd = new ArchiveActivityCommand(state.id, card.id);

    cmd.BoardActivity = boardActivity;

    return cmd;
};

export const createRestoreArchivedActivityCommand = async (action: RestoreArchivedActivity) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const activityId = await uuid.create();

    const boardActivity: any = {
        CardId: action.id,
        CardName: action.activityTitle,
        Datetime: new Date().toJSON(),
        OriginalContent: action.activityTitle,
        Id: activityId,
        StorymapId: state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
        Type: BoardUserActivityType.ActivityRestoredFromArchived,
    };

    const cmd = new RestoreArchivedActivityCommand(state.id, action.id);

    cmd.BoardActivity = boardActivity;

    return cmd;
};
